import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { useLocale } from 'src/providers/LocaleProvider';

export function useCurrencyFormatter() {
  const { currency } = useLocale();
  const intl = useIntl();

  return useCallback((price: number) => (
    (intl.formatNumber(price, { style: 'currency', currency }))
  ), [intl, currency]);
}
